import { Injectable } from '@angular/core';

import { AngularFirestore } from '@angular/fire/firestore';

import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class MovieService {

  constructor(
    private afs: AngularFirestore,
  ) { }

  public getMovie(pathId: string): Observable<any[]> {
    return this.afs
      .collection('movies', (ref) => ref.where('path', '==', pathId))
      .snapshotChanges().
      pipe(
        map(movies => {
          return movies.map((snapShot) => {
            const movieData: any = snapShot.payload.doc.data();
            return {
              ...movieData,
              id: snapShot.payload.doc.id,
              expiration: movieData.expiration.toDate(),
            };
          });
        })
      );
  }

  public addMovies(movies: any[]) {
    const moviesRef = this.afs.collection('movies').ref;

    return new Promise((resolve) => {
      for (const movie of movies) {
        movie.expiration = new Date(movie.expiration);
        moviesRef.add(movie);
      }

      resolve(true);
    });
  }
}
